import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const disconnectFromWhatsappAccount = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop-whatsapp-account',
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
    });
}